import React from 'react';
import { ActivityIcon, CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
import { Button } from './ui/Button';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [TrendingUpIcon, 'Progresivo'], [ActivityIcon, 'Práctico']] as const;
export function Hero() {
  return <section className="relative overflow-hidden bg-white px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-184" data-mp="12861s1aa6gsn">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" data-id="element-185" data-mp="xbpc32nfnudg" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-186" data-mp="nc894szkful6">
        <div className="mb-5 inline-flex rounded-full border border-primary/25 bg-mist px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-primary md:mb-6" data-id="element-187" data-mp="nbonb16som1v">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-188" data-mp="384jsewrv5frv">
          Entrenamiento en Casa
          <span className="mt-3 block text-xl normal-case text-primary md:text-4xl" data-id="element-189" data-mp="3o6apvvoqw6zy">
            Combo Completo — Programa de 6 Meses
          </span>
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del programa Entrenamiento en Casa" data-id="element-190" data-mp="3e961dp7ffzfz">
          <img className="w-full max-w-[680px] object-contain drop-shadow-[0_26px_44px_rgba(226,85,44,.24)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del programa Entrenamiento en Casa con sus 5 módulos y 3 bonos" data-id="element-191" data-mp="358zqmb345dki" />
        </a>

        <p className="mx-auto max-w-3xl text-base font-semibold leading-relaxed text-ink/70 md:text-xl" data-id="element-192" data-mp="2hjoyfhztwrhz">
          <strong className="text-ink" data-id="element-193" data-mp="2lk8ra9ddd8yb">Tu programa de 6 meses. Listo. Desde hoy.</strong> Todo lo
          que necesitás para entrenar en casa durante 6 meses sin improvisar: programa progresivo
          con bandas elásticas, ejercicios listos para usar, rutinas por fase y bonificaciones
          incluidas.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-ink/70 md:text-sm" data-id="element-194" data-mp="i9vqb23hxwks">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-195" data-mp="1b0du65c1o1z9">
              <BadgeIcon className="h-4 w-4 text-primary" data-id="element-196" data-mp="161jbr4hzoffo" />
              {label}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-197" data-mp="11152xk8kd1gl">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:px-10 md:py-5 md:text-lg" data-id="element-198" data-mp="114kjyslsskkn">
            🎯 QUIERO MI PROGRAMA AHORA →
          </Button>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-ink/55 md:text-sm" data-id="element-199" data-mp="3lu9w2xv49s9n">
          <span className="flex items-center gap-1" data-id="element-200" data-mp="1x9b42xkwqvaz">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-201" data-mp="1xam4qoj23mxv" />
            Garantía 7 días
          </span>
          <span className="text-accent" data-id="element-202" data-mp="21bfxpwbcvrxm">·</span>
          <span className="flex items-center gap-1" data-id="element-203" data-mp="26a96xcjm0wrz">
            <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-204" data-mp="268odxrcy1lw8" />
            Pago seguro
          </span>
          <span className="text-accent" data-id="element-205" data-mp="2b20sf8nwscb9">·</span>
          <span className="flex items-center gap-1" data-id="element-206" data-mp="2g0c1viaakksy">
            <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-207" data-mp="2fziymrajkdfk" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-208" data-mp="2p0h7pnzu7b50">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-line bg-canvas p-4 text-center shadow-sm" data-id="element-209" data-mp="2tztte5ez2c60">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-210" data-mp="uokdxodx9t6s">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-ink/60 md:text-sm" data-id="element-211" data-mp="zlswhq2zfz8k">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}